import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import WorksList from "@/pages/works/page";
import WorksDetail from "@/pages/works/detail/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsList /> },
      { path: "news/detail/:id", element: <NewsDetail /> },
      { path: "works", element: <WorksList /> },
      { path: "works/detail/:id", element: <WorksDetail /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;